import template from './validation-warning.html';

const DIRECTIVE_NAME = ValidationWarning.DIRECTIVE_NAME = 'ktValidationWarning';
export default function ValidationWarning() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: ValidationWarningController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            continue: `&${DIRECTIVE_NAME}Continue`,
            cancel: `&${DIRECTIVE_NAME}Cancel`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function ValidationWarningController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/validation-warning/validation-warning-component.js